import { render, staticRenderFns } from "./SelectGroups.vue?vue&type=template&id=937c6514&"
import script from "./SelectGroups.vue?vue&type=script&lang=js&"
export * from "./SelectGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('937c6514')) {
      api.createRecord('937c6514', component.options)
    } else {
      api.reload('937c6514', component.options)
    }
    module.hot.accept("./SelectGroups.vue?vue&type=template&id=937c6514&", function () {
      api.rerender('937c6514', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/components/SelectGroups.vue"
export default component.exports